import { WordType } from "../types";

export const flags = {
    korean: "🇰🇷",
    tomikorean: "🇰🇷",
    japanese: "🇯🇵",
    spanish: "🇪🇸",
    swedish: "🇸🇪",
    arabic: "🇦🇪",
    turkish: "🇹🇷",
};

export const languageTitles = {
    korean: "korean",
    tomikorean: "korean",
    japanese: "japanese",
    spanish: "spanish",
    swedish: "swedish",
    arabic: "arabic",
    turkish: "turkish",
};

export const wordTypes: WordType[] = [
    "verb",
    "verb (base)",
    "verb (past)",
    "verb (present)",
    "verb (future)",
    "noun",
    "adjective",
    "adverb",
    "preposition",
    "pronoun",
    "interjection",
];

export const languages = {
    korean: "Korean",
    tomikorean: "Tomi Korean",
    japanese: "Japanese",
    spanish: "Spanish",
    swedish: "Swedish",
    arabic: "Arabic",
    turkish: "Turkish",
};
